import React, { useCallback, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useStore } from '../../store';
import { OPEN_POP_UP, CLOSE_POP_UP } from '../../constant/action';
import { getUserStartPage, getSideBarList, isAdminRoute, getAdminStartPage, isPredicare } from '../util';
import AccountUserChanger from './accountUserChanger';
import LanguageChanger from './languageChanger';
import PasswordChanger from './passwordChanger';
import { withTranslation } from '../common/translation';
import { RettsLogo, OmdaLogoWhite } from '../common/icon';
import { isLoggedIn, getRoleId } from '../../api/util';
import { ROLES, DEFAULT_USER_ROLE_ID, DEPARTMENT_USER_ROLE_ID } from '../../constant/route';
import { ADMIN, USER, EMPTY_STRING } from '../../constant/text';
import { getElearningLink } from '../../api/user';
import { useLoginManager } from '../../UseLoginManager';
import { getViewToggleClassName } from './sideBarHelper';

const SideBar = props => {
    const { t, i18n, setSideNavOpen, sideNavOpen = false } = props;
    const { logout } = useLoginManager();
    const { dispatch } = useStore();
    const closePopUp = useCallback(payload => dispatch({ type: CLOSE_POP_UP, payload }), [dispatch]);
    const openPopUp = useCallback(payload => dispatch({ type: OPEN_POP_UP, payload }), [dispatch]);
    const [eLearningLink, setElearningLink] = useState(null);
    const history = useHistory();

    useEffect(() => {
        (async () => {
            if (eLearningLink === null && sideNavOpen === true) {
                const response = await getElearningLink();
                const eLearningLinkUrl = new URL(response.autoLoginLink ?? response.baseUrl);
                eLearningLinkUrl.searchParams.set('lang', i18n.language);
                setElearningLink(eLearningLinkUrl.toString());
            }
        })();
    }, [eLearningLink, i18n.language, sideNavOpen]);

    const SETTINGS_MENU = {
        CHANGE_LANGUAGE: () => openPopUp({ component: <LanguageChanger /> }),
        CHANGE_ACCOUNT: () => openPopUp({ component: <AccountUserChanger /> }),
        CHANGE_PASSWORD: () => openPopUp({ component: <PasswordChanger /> })
    };

    let settings = getSideBarList(SETTINGS_MENU);

    if (!isPredicare()) {
        settings = settings.filter(item => item.label !== 'CHANGE_LANGUAGE');
    }

    if (!isLoggedIn()) {
        settings = settings.filter(item => item.label !== 'CHANGE_PASSWORD' && item.label !== 'CHANGE_ACCOUNT');
    }

    if (getRoleId() === DEPARTMENT_USER_ROLE_ID) {
        settings = settings.filter(item => item.label !== 'CHANGE_PASSWORD');
    }

    const onItemClick = item => {
        SETTINGS_MENU[item]();
        setSideNavOpen(false);
    };

    const onLogout = () => {
        logout();
        closePopUp();
        setSideNavOpen(false);
        history.push('/');
    };

    const toggleView = () => {
        if (isAdminRoute()) {
            history.push(getUserStartPage());
        } else {
            history.push(getAdminStartPage());
        }
        setSideNavOpen(false);
    };

    return (
        <div className={`sidenav ${sideNavOpen ? 'sidenavOpen' : EMPTY_STRING}`} id="sidenav">
            <div className="sidenavLogo">
                <RettsLogo />
            </div>
            {
                settings.map(item => <div className="sidenavItem" key={item.value} onClick={() => onItemClick(item.value)}>{t(item.label)}</div>)
            }
            {
                isLoggedIn() && isAdminRoute() && ROLES[getRoleId()].adminView && (
                    <div className={getViewToggleClassName()}>
                        <Link to={ROLES[DEFAULT_USER_ROLE_ID].homePage} onClick={() => toggleView()} className={'link'}>
                            {t('TYPE_OF_VIEW', { typeOfView: (isAdminRoute() ? t(USER) : t(ADMIN)) })}
                        </Link>
                    </div>
                )
            }

            {
                isLoggedIn() && !isAdminRoute() && ROLES[getRoleId()].adminView && (
                    <div className={getViewToggleClassName()}>
                        <Link to={getAdminStartPage()} onClick={() => toggleView()} className={'link'}>
                            {t('TYPE_OF_VIEW', { typeOfView: (isAdminRoute() ? t(USER) : t(ADMIN)) })}
                        </Link>
                    </div>
                )
            }
            {isLoggedIn() && (
                <div className="sidenavItem">
                    <a
                        className="link"
                        href={eLearningLink}
                        style={{ display: 'block' }}
                        rel="noopener noreferrer"
                        target="_blank">
                        {t('OPEN_E_LEARNING')}
                    </a>
                </div>
            )}
            <div className="sidenavItem">
                <a
                    className="link"
                    href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}
                    style={{ display: 'block' }}>
                    {t('SUPPORT')}
                </a>
            </div>
            {
                isLoggedIn() && <div className="logout" onClick={() => onLogout()}>{t('LOGOUT')}</div>
            }
            <div className="sidenavFooter">
                <OmdaLogoWhite />
                <div className="sidenavCopyright">©{new Date().getFullYear()} {t('WEB_COPYRIGHT_NOTICE')}</div>
            </div>
        </div>
    );
};

export default React.memo(withTranslation()(SideBar));
